export default "__VITE_ASSET__QXqN18Yg__"